import ethereum from '../../../assets/images/ethereum.png';

export default { ethereum };
